import script from "./CookieConsent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieConsent.vue?vue&type=script&lang=ts&setup=true"

import "./CookieConsent.vue?vue&type=style&index=0&id=123eccd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123eccd8"]])

export default __exports__